const getREMFromPX = (px: number) => `${px / 16}rem`;
export default getREMFromPX;
